import React from "react";
import "./style.scss";

const StatusTag = ({
	icon, //ReactComponent
	children,
	color,
	className,
}) => {
	return (
		<div className="status-tag">
			<div className="background" style={{ backgroundColor: color }}></div>
			{icon && icon}
			<div className="text" style={{ color: color }}>
				{children}
			</div>
		</div>
	);
};

export default StatusTag;
